export default __webpack_public_path__ + "static/media/game.02a6059e.jpg";